export default {
  id: 173,
  title: 'Target #173 - Hockey Mask',
  url: 'https://cssbattle.dev/play/173',
  colors: ['#A5B5B4', '#FFFFFF', '#000000'],
  solution:
    '<a a><a b><a c><a d><a e><style>a[c],a[d],a[e]{width:10;height:10}body{background:#a5b5b4}a{position:fixed;background:#000;border-radius:100%}a[a]{background:#fff;width:150;height:180;top:60;left:125}a[b]{width:30;height:30;top:110;left:150;box-shadow:70px 0}a[c],a[d]{top:80;left:180;box-shadow:0 80px,0 100px,0 120px}a[d]{left:210}a[e]{top:100;left:195}</style>',
}
